import React from "react";
import imgDiv from "../assets/images/coming soon image 1.png";
import imgDiv1 from "../assets/images/cominng soon image 2.png";
import imgDiv2 from "../assets/images/cominng soon image3.png";
import imgDiv3 from "../assets/images/cominng soon image 4.png";
import imgDiv4 from "../assets/images/cominng soon image 5.png";
import imgDiv5 from "../assets/images/cominng soon image 6.png";
import imgDiv6 from "../assets/images/coming soon image 1.png";
import imgDiv7 from "../assets/images/cominng soon image 2.png";

function ComingSoonNotifyButton() {
  return (
    <div className="relative cursor-pointer select-none pb-[25px] pl-[20px] pr-[20.578px] pt-[23px] rounded-[64px] transition-all hover:scale-105 active:scale-95" data-name="a">
      <div aria-hidden className="absolute bg-[#107cf7] inset-0 pointer-events-none rounded-[64px]" />
      <div className="[word-break:break-word] flex flex-col font-['Inter:Semi_Bold',sans-serif] font-semibold justify-center leading-[0] not-italic relative shrink-0 text-[16px] text-center text-white whitespace-nowrap z-10">
        <p className="leading-[0px]">Notify me</p>
      </div>
      <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_1px_1px_1px_0px_rgba(255,255,255,0.25)]" />
    </div>
  );
}

function ComingSoonTextWrapper() {
  return (
    <div className="h-auto flex flex-col items-center gap-6 relative w-full lg:w-[768px] lg:shrink-0" data-name="div">
      <div className="[word-break:break-word] flex flex-col font-['Sarina:Regular',sans-serif] justify-center leading-tight not-italic text-[#107cf7] text-6xl md:text-8xl text-center tracking-[-3px]">
        <h2 className="mb-0">Coming soon</h2>
      </div>
      <div className="[word-break:break-word] flex flex-col font-['Inter:Regular',sans-serif] font-normal justify-center text-center text-base md:text-xl text-black max-w-2xl px-4">
        <p className="leading-relaxed">
          Your trusted platform for home services is almost here. Stay tuned for a faster, smarter, and more convenient way to care for your home.
        </p>
      </div>
      <ComingSoonNotifyButton />
    </div>
  );
}

function ComingSoonGridRowTop() {
  return (
    <div className="absolute h-[158.391px] left-[130.06px] top-0 w-[2030.375px]" data-name="div">
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%-770.39px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[512px] size-full" src={imgDiv} />
      </div>
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%-256.79px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[512px]">
          <img alt="" className="absolute h-[247.37%] left-[-0.08%] max-w-none top-[-123.44%] w-full" src={imgDiv1} />
        </div>
      </div>
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%+256.8px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[512px]">
          <img alt="" className="absolute h-[158.97%] left-0 max-w-none top-[-59.13%] w-full" src={imgDiv2} />
        </div>
      </div>
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%+770.39px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[512px]">
          <img alt="" className="absolute h-[105.49%] left-0 max-w-none top-[-2.74%] w-full" src={imgDiv3} />
        </div>
      </div>
    </div>
  );
}

function ComingSoonGridRowBottom() {
  return (
    <div className="absolute h-[158.391px] left-[-130.07px] top-[190.39px] w-[2030.375px]" data-name="div">
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%-770.39px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[512px]">
          <img alt="" className="absolute h-[106.33%] left-0 max-w-none top-[-3.17%] w-full" src={imgDiv4} />
        </div>
      </div>
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%-256.79px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <div className="absolute inset-0 overflow-hidden pointer-events-none rounded-[512px]">
          <img alt="" className="absolute h-[247.37%] left-[0.09%] max-w-none top-[-133.44%] w-full" src={imgDiv5} />
        </div>
      </div>
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%+256.8px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[512px] size-full" src={imgDiv6} />
      </div>
      <div className="-translate-x-1/2 absolute h-[158.391px] left-[calc(50%+770.39px)] rounded-[512px] top-0 w-[489.594px]" data-name="div">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[512px] size-full" src={imgDiv7} />
      </div>
    </div>
  );
}

function ComingSoonImagesContainer() {
  return (
    <div className="h-[348.781px] relative shrink-0 w-[2030.375px] overflow-hidden lg:overflow-visible scale-75 md:scale-90 lg:scale-100 origin-center" data-name="div">
      <ComingSoonGridRowTop />
      <ComingSoonGridRowBottom />
    </div>
  );
}

export default function ComingSoon() {
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col gap-12 items-center py-12 lg:h-[1038px] lg:w-[1440px] lg:mx-auto lg:block lg:py-0" data-name="section">
      <div className="relative flex flex-col gap-16 items-center w-full lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-[25px] lg:w-[1440px]" data-name="div">
        <ComingSoonTextWrapper />
        <ComingSoonImagesContainer />
      </div>
    </div>
  );
}